import { resetMobileUrl as baseUrl, requestJson, NEED_CAPTCHA_CODE, NEED_SECOND_CAPTCHA_CODE, gaiaKey } from './config'
import { handleResponse, getConstId } from './utils'
import { myAxios } from '../utils'

export const sendSmsOldURL = `${baseUrl}/send-old` // 短验方式改手机号-给旧号发短信
export const smsOldURL = `${baseUrl}/sms-old` // 短验方式改手机号-给旧号发短信后-填写验证码
export const sendSmsNewURL = `${baseUrl}/send-newSecret` // 修改手机号-给新号发短信
export const smsNewUrl = `${baseUrl}/sms-newSecret` // 修改手机号-给新号发短信后-填写验证码
export const submitPwdUrl = `${baseUrl}/pwd` // 修改手机号-验证密码
export const uploadImage = `${baseUrl}/upload` // 修改手机号-上传入网证明
export const checkPhoneNumberStateUrl = `${baseUrl}/check` // 修改手机号-校验手机号状态
export const submitProofImageUrl = `${baseUrl}/submitSecret` // 修改手机号-上传入网证明后提交

/*
* 更改手机号-给旧手机号发短信
* */
export const sendSmsOld = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(sendSmsOldURL, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res, [ NEED_CAPTCHA_CODE, NEED_SECOND_CAPTCHA_CODE ])
    })
}
/*
* 更改手机号-给新手机号发送短信
* */
export const sendSmsNew = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(sendSmsNewURL, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res, [ NEED_CAPTCHA_CODE, NEED_SECOND_CAPTCHA_CODE ])
    })
}
/*
* 更改手机号-给旧手机号发送短信后-提交短信验证码
*  */
export const submitSmsOld = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(smsOldURL, paramsData, {
    loading: {
      message: '校验中'
    },
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}

/*
* 更改手机号-给新手机号发送短信后-提交短信验证码
*  */
export const submitSmsNew = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(smsNewUrl, paramsData, {
    loading: {
      message: '校验中'
    },
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}

/*
* 更改手机号-密码方式修改-提交密码
*  */
export const submitPwd = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(submitPwdUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}

/*
* 更改手机号-上传手机号入网证明
*  */
export const uploadOnlineProofImage = async (file) => {
  const { token, channel, bu_code } = await requestJson()
  let param = new FormData()
  // 将得到的文件流添加到FormData对象
  param.append('file', file, file.name)
  param.set('token', token)
  param.set('channel', channel)
  param.set('bu_code', bu_code)

  return myAxios.post(uploadImage, param, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    },
    loading: false
  })
    .then((res) => {
      return handleResponse(res)
    })
}

/*
* 更改手机号-检查手机号状态
*  */
export const checkPhoneNumberState = async (params) => {
  let paramsData = {
    ...await requestJson(),
    ...params
  }
	try {
		const fingerprint = await getConstId()
		if (fingerprint) {
			paramsData.fingerprint = fingerprint
		}
	} catch {
		console.log('获取设备指纹失败')
	}

  return myAxios.post(checkPhoneNumberStateUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}/*
* 更改手机号-上传入网证明后提交
*  */
export const submitProofImage = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }

  return myAxios.post(submitProofImageUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}
